import { Action } from '@ngrx/store';
import { ActiveClientsActionsTypes } from '../active-clients/active-clients.actions';

export enum UserActionsTypes {
  LoadUser = '[User] Load user',
  LoadUserSuccess = '[User] Load user success',

  LoadLocations = '[User] Load user locations',
  LoadLocationsSuccess = '[User] Load user locations success',

  LoadUserEventNotifications = '[User] Load User Event Notifications',
  LoadUserEventNotificationsSuccess = '[User] Load User Event Notifications Success',

  LoadUserMessageNotifications = '[User] Load User Message Notifications',
  LoadUserMessageNotificationsSuccess = '[User] Load User Message Notifications Success',

  LoadMoreEventNotifications = '[User] Load More Event Notifications',
  LoadMoreEventNotificationsSuccess = '[User] Load More Event Notifications Success',

  LoadMoreMessageNotifications = '[User] Load More Message Notifications',
  LoadMoreMessageNotificationsSuccess = '[User] Load More Message Notifications Success',

  LoadNotificationCount = '[User] Load Notification Count',
  LoadNotificationCountSuccess = '[User] Load Notification Count Success',

  ReadAllNotifications = '[User] Read All Notifications',
  ReadAllNotificationsSuccess = '[User] Read All Notifications Success',

  ReadEventNotifications = '[User] Read Event Notifications',
  ReadEventNotificationsSuccess = '[User] Read Event Notifications Success',

  ReadMessageNotification = '[User] Read Message Notifications',
  ReadMessageNotificationSuccess = '[User] Read Message Notifications Success',

  EditUser = '[User] edit user',

  UploadUserFoto = '[User] upload user foto',

  ClearUserFoto = '[User] remove user foto',

  ChageUserPassword = '[User] change user password',

  ResetDefaultSortLocations = '[User] Rese tDefault Sort Locations',

  Error = '[User] Error',
}

// #region load user
export class LoadUser implements Action {
  readonly type = UserActionsTypes.LoadUser;
  constructor(public payload?: any) {}
}

export class LoadUserSuccess implements Action {
  readonly type = UserActionsTypes.LoadUserSuccess;
  constructor(public payload: any) {}
}
// #endregion

// #region load user locations
export class LoadLocations implements Action {
  readonly type = UserActionsTypes.LoadLocations;
  constructor(public id: any) {}
}

export class LoadLocationsSuccess implements Action {
  readonly type = UserActionsTypes.LoadLocationsSuccess;
  constructor(public payload: any) {}
}
// #endregion

// #region edit user
export class EditUser implements Action {
  readonly type = UserActionsTypes.EditUser;
  constructor(
    public id: any,
    public payload: any,
  ) {}
}
// #endregion

// #region upload user foto
export class UploadUserFoto implements Action {
  readonly type = UserActionsTypes.UploadUserFoto;
  constructor(
    public id: any,
    public payload: any,
  ) {}
}
// #endregion

// #region upload user foto
export class ClearUserFoto implements Action {
  readonly type = UserActionsTypes.ClearUserFoto;
  constructor(public id: any) {}
}
// #endregion

// #region change user password
export class ChageUserPassword implements Action {
  readonly type = UserActionsTypes.ChageUserPassword;
  constructor(
    public id: any,
    public payload: any,
  ) {}
}
// #endregion

// #region load user notification
export class LoadUserEventNotifications implements Action {
  readonly type = UserActionsTypes.LoadUserEventNotifications;
  constructor() {}
}

export class LoadUserEventNotificationsSuccess implements Action {
  readonly type = UserActionsTypes.LoadUserEventNotificationsSuccess;
  constructor(public payload: any) {}
}
export class LoadUserMessageNotifications implements Action {
  readonly type = UserActionsTypes.LoadUserMessageNotifications;
  constructor() {}
}

export class LoadUserMessageNotificationsSuccess implements Action {
  readonly type = UserActionsTypes.LoadUserMessageNotificationsSuccess;
  constructor(public payload: any) {}
}

export class LoadMoreEventNotifications implements Action {
  readonly type = UserActionsTypes.LoadMoreEventNotifications;
  constructor(public payload: string) {}
}

export class LoadMoreEventNotificationsSuccess implements Action {
  readonly type = UserActionsTypes.LoadMoreEventNotificationsSuccess;
  constructor(public payload: any) {}
}

export class LoadMoreMessageNotifications implements Action {
  readonly type = UserActionsTypes.LoadMoreMessageNotifications;
  constructor(public payload: string) {}
}

export class LoadMoreMessageNotificationsSuccess implements Action {
  readonly type = UserActionsTypes.LoadMoreMessageNotificationsSuccess;
  constructor(public payload: any) {}
}

export class LoadNotificationCount implements Action {
  readonly type = UserActionsTypes.LoadNotificationCount;
}

export class LoadNotificationCountSuccess implements Action {
  readonly type = UserActionsTypes.LoadNotificationCountSuccess;
  constructor(public payload: number) {}
}

// #endregion

// #region read user notifications
export class ReadEventNotifications implements Action {
  readonly type = UserActionsTypes.ReadEventNotifications;
  constructor(public payload: Array<number | string>) {}
}

export class ReadAllNotifications implements Action {
  readonly type = UserActionsTypes.ReadAllNotifications;
  constructor() {}
}

export class ReadAllNotificationsSuccess implements Action {
  readonly type = UserActionsTypes.ReadAllNotificationsSuccess;
  constructor() {}
}

export class ReadEventNotificationSuccess implements Action {
  readonly type = UserActionsTypes.ReadEventNotificationsSuccess;
  constructor(public payload: any) {}
}

export class ReadMessageNotification implements Action {
  readonly type = UserActionsTypes.ReadMessageNotification;
  constructor(public payload: number[]) {}
}

export class ReadMessageNotificationSuccess implements Action {
  readonly type = UserActionsTypes.ReadMessageNotificationSuccess;
  constructor(public payload: any) {}
}

export class ResetDefaultSortLocations implements Action {
  readonly type = UserActionsTypes.ResetDefaultSortLocations;
  constructor() {}
}

// # end region

// #region ERROR

export class Error implements Action {
  readonly type = UserActionsTypes.Error;
  constructor(public payload: string) {}
}
// #endregion

export type UserActions =
  | LoadUser
  | LoadUserSuccess
  | LoadLocations
  | LoadLocationsSuccess
  | LoadUserEventNotifications
  | LoadUserEventNotificationsSuccess
  | LoadUserMessageNotifications
  | LoadUserMessageNotificationsSuccess
  | LoadNotificationCount
  | LoadNotificationCountSuccess
  | LoadMoreEventNotifications
  | LoadMoreEventNotificationsSuccess
  | LoadMoreMessageNotifications
  | LoadMoreMessageNotificationsSuccess
  | ReadEventNotifications
  | ReadEventNotificationSuccess
  | ReadAllNotifications
  | ReadAllNotificationsSuccess
  | ReadMessageNotification
  | ReadMessageNotificationSuccess
  | EditUser
  | UploadUserFoto
  | ClearUserFoto
  | ChageUserPassword
  | ResetDefaultSortLocations
  | Error;
